import { render } from "./services.vue?vue&type=template&id=1f2a1b92"
const script = {}

import exportComponent from "C:\\Users\\abolfazl\\Desktop\\New folder\\vue-tailwind\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__